export const DATA_LEVEL_7 = 7;
export const DATA_LEVEL_15 = 15;

export default {
    DATA_LEVEL_7,
    DATA_LEVEL_15,
};
